import React, { Component } from "react";

export default class DentEditorTable extends Component {
  render() {
    const {
      lang,
      A,
      B,
      C,
      D,
      E,
      dentsCount,
      prePopulatePartName,
      isCoopClient,
    } = this.props;
    const client = localStorage.getItem("client");
    const isCanadaClient = "CANADA" === client;
    return (
      <>
        <table className="table table-striped table-responsive">
          <thead>
            {/* part heading */}
            <th scope="col" width="40%">
              {lang("Part")}
            </th>
            {/* A value heading */}
            <th scope="col" width="10%">
              {["US", "CANADA"].includes(client)
                ? lang("DIME")
                : client == "AUT"
                ? lang("Light-at")
                : lang("A")}
            </th>
            {/* B value heading */}
            <th scope="col" width="10%">
              {["US", "CANADA"].includes(client)
                ? isCanadaClient && isCoopClient
                  ? lang("QTR")
                  : lang("NKL")
                : client == "AUT"
                ? lang("Medium")
                : lang("B")}
            </th>
            {/* C value heading */}

            <th scope="col" width="10%">
              {["US", "CANADA"].includes(client)
                ? isCanadaClient && isCoopClient
                  ? lang("TOONIE")
                  : lang("QTR")
                : client == "AUT"
                ? lang("Heavy")
                : lang("C")}
            </th>
            {/* D value heading */}
            {(["US", "CANADA"].includes(client) || client == "FR") && (
              <th scope="col" width="10%">
                {["US", "CANADA"].includes(client)
                  ? isCanadaClient
                    ? lang("OS")
                    : lang("HALF")
                  : lang("D")}
              </th>
            )}
            {/* E value heading */}
            {client == "US" && (
              <th scope="col" width="10%">
                {lang("OS")}
              </th>
            )}
            {/* Total value heading */}
            <th
              scope="col"
              width="30%"
              style={{ wordBreak: "inherit", whiteSpace: "normal" }}
            >
              {lang("Total Dents")}
            </th>
          </thead>
          <tbody>
            <tr>
              <td style={{ wordBreak: "inherit", whiteSpace: "normal" }}>
                {lang(prePopulatePartName)}
              </td>
              <td>{A}</td>
              <td>{isCanadaClient && isCoopClient ? C : B}</td>
              <td>{isCanadaClient && isCoopClient ? B : C}</td>
              {(["US", "CANADA"].includes(client) || client == "FR") && (
                <td>{D ? D : 0}</td>
              )}
              {client == "US" && <td>{E ? E : 0}</td>}
              <td>{dentsCount}</td>
            </tr>
          </tbody>
        </table>
      </>
    );
  }
}
